module.exports = __webpack_public_path__ + "img/24.76749e0d.jpg";